<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav class="pull-left">
        <ul>
          <li>
            <a href="https://www.bwpremieraddis.com/" target="_blank">
              Best Western Premier Dynasty
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright pull-right">
        &copy; 2025, Developed by
                <a href="https://www.thebluhart.com" target="_blank">BluHart Marketing</a>
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>
